import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function LetterSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-20 md:py-32 bg-[#020202] relative" data-id="element-161">
      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-162">
        <motion.div ref={ref} initial="hidden" animate={isVisible ? 'visible' : 'hidden'} variants={containerVariants} className="glass-card p-8 md:p-12 rounded-3xl text-center" data-id="element-163">
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-164">
            <motion.h3 variants={itemVariants} className="text-3xl md:text-5xl font-extrabold text-white mb-8" data-id="element-165">
              Necesitás 100 creativos.
            </motion.h3>

            <motion.p variants={itemVariants} className="text-xl md:text-2xl" data-id="element-166">
              La matemática es simple:{' '}
              <strong className="text-white" data-id="element-167">
                Solo 5-10 de cada 100 creativos la rompen.
              </strong>
            </motion.p>

            <motion.div variants={itemVariants} className="my-10 p-8 rounded-2xl bg-white/[0.03] border border-white/10" data-id="element-168">
              <p className="font-medium text-white text-2xl md:text-3xl leading-relaxed" data-id="element-169">
                Si testeás 5, es lotería. <br data-id="element-170" />
                <span className="text-purple-400 font-bold mt-2 block" data-id="element-171">
                  Si testeás 100, es estadística.
                </span>
              </p>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="pt-6" data-id="element-172">
            <a href="#pricing" className="inline-block bg-white text-black hover:bg-gray-200 font-bold py-4 px-10 rounded-full transition-all shadow-lg hover:shadow-white/20 transform hover:-translate-y-1" data-id="element-173">
              ACCEDER A LA APP →
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}